export const parseGameIdList = (value, gamesById, availableIds, currentIds) => {
	const seen = new Set(currentIds);
	const tokens = [...value.matchAll(/[^\s,;]+/g)].map((match) => {
		const raw = match[0];
		const token = { raw, start: match.index, end: match.index + raw.length, gameId: null, status: "invalid" };
		if (!/^\d+$/.test(raw) || !Number.isSafeInteger(Number(raw)) || Number(raw) <= 0) return token;
		token.gameId = String(Number(raw));
		if (!gamesById.has(token.gameId)) token.status = "unknown";
		else if (!availableIds.has(token.gameId)) token.status = "unavailable";
		else if (currentIds.has(token.gameId)) token.status = "already-present";
		else if (seen.has(token.gameId)) token.status = "duplicate";
		else {
			token.status = "valid";
			seen.add(token.gameId);
		}
		return token;
	});
	if (!tokens.length) return { error: "Enter at least one Game ID.", tokens };
	const valuesForStatus = (status) => [...new Set(tokens.filter((token) => token.status === status).map((token) => status === "invalid" ? token.raw : token.gameId))];
	const invalid = valuesForStatus("invalid");
	const unknown = valuesForStatus("unknown");
	const unavailable = valuesForStatus("unavailable");
	if (invalid.length || unknown.length || unavailable.length) {
		return { error: [
			invalid.length ? `Invalid Game IDs: ${invalid.join(", ")}. Use positive whole numbers.` : "",
			unknown.length ? `Unknown Game IDs: ${unknown.join(", ")}.` : "",
			unavailable.length ? `Unavailable Game IDs: ${unavailable.join(", ")}.` : "",
		].filter(Boolean).join(" "), tokens };
	}
	return {
		gameIds: tokens.filter((token) => token.status === "valid").map((token) => token.gameId),
		skippedIds: [...new Set(tokens.filter((token) => token.status === "duplicate" || token.status === "already-present").map((token) => token.gameId))],
		tokens,
	};
};

export const applyBadgeToGames = (assignmentsByGameId, gameIds, assignment, isSameBadge) => {
	const next = { ...assignmentsByGameId };
	gameIds.forEach((gameId) => {
		next[gameId] = [
			...(assignmentsByGameId[gameId] || []).filter((current) => current.position !== assignment.position && !isSameBadge(current, assignment)),
			{ ...assignment },
		];
	});
	return next;
};

export const clearBadgesForGames = (assignmentsByGameId, gameIds) => {
	const next = { ...assignmentsByGameId };
	gameIds.forEach((gameId) => { next[gameId] = []; });
	return next;
};

const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

export const parseSectionJson = (value) => {
	const data = JSON.parse(value);
	const fields = ["version", "game_ids"];
	if (!isObject(data) || Object.keys(data).length !== fields.length || fields.some((field) => !Object.prototype.hasOwnProperty.call(data, field))) {
		throw new Error(`Expected exactly these fields: ${fields.join(", ")}.`);
	}
	if (data.version !== 1) throw new Error("Unsupported section JSON version. Expected version 1.");
	if (!Array.isArray(data.game_ids) || data.game_ids.some((id) => !Number.isSafeInteger(id) || id <= 0) || new Set(data.game_ids).size !== data.game_ids.length) {
		throw new Error("game_ids must be a unique ordered array of positive whole numbers.");
	}
	return data;
};
